import { UserProfile } from "@api/models/UserProfile";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { Notice } from "@service/components/toast/type/Notice";
import { MessageType } from "./NoticeProxy";
import i18n from "@service/locale/i18";

interface NoticeFabricInterface {
    getRaiseHandMessage<T extends UserProfile | unknown>(userProfiles: T[], groupId?: string): Notice[];
}

export class NoticeFabric implements NoticeFabricInterface {

    getMessage<T>(data: T[], messageType: MessageType, groupId?: string): Notice[] {
        const method = `get${messageType}Message` as keyof NoticeFabricInterface;

        return this[method](data, groupId);
    }

    /**
     * message for hand raise notice
     * @param userProfiles
     * @returns
     */
    getRaiseHandMessage<T extends UserProfile | unknown>(userProfiles: T[], groupId?: string) {

        return userProfiles.map((profile) => {

            if (profile instanceof UserProfile) {
                const notice: Notice = {
                    level: NoticeLevel.warning,
                    text: `${profile.fullName} ${i18n.t("web-conferences.raisedHand").toString().toLocaleLowerCase()}`,
                    ...(groupId ? { groupId: groupId } : null),
                    key: profile.userId
                }

                return notice;
            }
            else {
                throw new Error("Unknown instance for create raise hand message");
            }
        });
    }
}